import { AppBrand } from 'constants/field-values';
import React, { createContext, useContext, ReactNode } from 'react';
import theme from 'styles/theme.json'

interface Theme {
  navbarImage: string;
  headerShoppingCartIcon: string;
  notificationIcon: string;
  noProfilePhotoIcon: string;
  viewTypeColors: string[];
  loginLogo: string;
  comingSoonImage: string;
  aiChatSubmitIcon: string[];
  systemChatIcon: string;
  aiChatPaperclipIcon: string;
  buttonStarImage: string;
  commentIcon: string;
}

interface BrandContextType {
  brand: AppBrand;
  theme: Theme;
}

// Create the context with default values
const BrandContext = createContext<BrandContextType | undefined>(undefined);

// Provider component props
interface BrandProviderProps {
  children: ReactNode;
}

// Provider component
export const BrandContextProvider: React.FC<BrandProviderProps> = ({
  children,
}) => {
  let brand: AppBrand = AppBrand.Highnote; // Default brand
  if (window.location.hostname.includes("maestro")) {
    brand = AppBrand.MaestroSync;
  }

  return (
    <BrandContext.Provider value={{ brand, theme: { ...theme.Highnote, ...theme[brand] } }}>
      {/* Every brand-scoped SCSS override (sidebar sizing, buttons, etc.) is written against
          this class, so it needs to wrap the whole app, not just the auth screens. */}
      <div className={`brand-container brand-${brand.toLowerCase()}`}>{children}</div>
    </BrandContext.Provider>
  );
};

// Custom hook to use the context
export const useBrand = (): BrandContextType => {
  const context = useContext(BrandContext);

  if (context === undefined) {
    throw new Error('useBrand must be used within a BrandProvider');
  }

  return context;
};

export default BrandContext;
